import styled from 'styled-components';
import { blenderCss } from '@clds/blender';

export const TextBlock = styled.div`
  ${blenderCss.typographyFromCssVariables('xxs')};
  margin: 0 ${(props) => props.theme.spacing.xxs};
`;
